import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FetchImageDirective } from '@core/directives/fetch-image.directive';
import { FilesDropDirective } from '@core/directives/files-drop.directive';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'xemex-upload-photo-component',
  imports: [MatIconModule, MatButtonModule, TranslateModule, FetchImageDirective],
  standalone: true,
  templateUrl: './upload-photo.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './upload-photo.component.scss',
})
export class UploadPhotoComponent {
  inputImage = input<string>('');
  image?: File;

  imageUrl = '';
  onSelectImage = output<File>();
  acceptedTypes = ['image/png', 'image/jpg', 'image/jpeg'];

  constructor(readonly dialog: MatDialog) {}

  handleInputFile(event: any) {
    const selectedFiles = event.target.files;

    if (selectedFiles) {
      const file: File | null = selectedFiles.item(0);

      if (file) {
        this.image = file;

        const reader = new FileReader();

        reader.onload = (e: any) => {
          this.imageUrl = e.target.result;
        };

        reader.readAsDataURL(this.image);
        this.onSelectImage.emit(file);
      }
    }
  }

  onFileDrop(files: any) {
    // console.log(files);
    // this.handleInputFile(files?.[0]);
    // this.dialog.open(CropPhotoDialogComponent, {
    //   width: '640px',
    //   height: '456px',
    //   maxWidth: '640px',
    //   data: {
    //     imageFile: files[0],
    //   },
    // });
    // .afterClosed()
    // .subscribe(result => {
    //   if (result) {
    //     this.dialogRef.close({
    //       croppedImage: result.croppedImage,
    //       imageBlob: result.imageBlob,
    //     });
    //   }
    // });
  }

  onFileSelected(event: any) {
    this.handleInputFile(event);
    // this.dialog.open(CropPhotoDialogComponent, {
    //   width: '640px',
    //   height: '456px',
    //   maxWidth: '640px',
    //   data: {
    //     imageFile: event.target.files[0],
    //   },
    // });
    // .afterClosed()
    // .subscribe(result => {
    //   if (result) {
    //     this.dialogRef.close({
    //       croppedImage: result.croppedImage,
    //       imageBlob: result.imageBlob,
    //     });
    //   }
    // });
  }
}
